import moment, { Moment } from 'moment';
import { environment } from '../../../../../environments/environment';
import { AbstractTestimonyResult } from '../../api-results/abstract-testimony/abstract-testimony.api-result';

export class AbstractTestimony {
  id: string;
  content: string;
  ecnRank: string;
  createdAt: Date;

  constructor(result: AbstractTestimonyResult) {
    this.id = result.id;
    this.content = result.content;
    this.ecnRank = result.ecnRank;

    if (result.createdAt) {
      this.createdAt = moment(result.createdAt).toDate();
    }
  }
}
